/**
 *
 * Styles for OfferCard
 *
 */

import styled from "styled-components";
import { Accordion } from "root/libs/ui-components/src";
import { breakpoints } from "root/libs/ui-styleguide/src";

export const OfferCardWrapper = styled.div`
  position: relative;
  width: 100%;
  background-color: var(--dui-color-white-500);
  box-shadow: rgb(229, 229, 229) 0px var(--gaq-size-space-3px)
    var(--dui-size-space-4x) 0px;
  transition: ease-in-out 200ms box-shadow;
  border-radius: var(--dui-size-radius-md);

  &.has-discount {
    padding-top: var(--dui-size-space-10x);

    @media screen and (min-width: ${breakpoints.tablet}) {
      padding-top: 0;
    }
  }

  > .accordion {
    width: 100%;
    margin: 0 0 var(--gaq-size-space-30px) 0;
    padding: 0;
  }

  .offerCollapsibleContent {
    margin-bottom: 0;
    padding: 0;

    &.expanded {
      padding: 2.1rem 2.1rem var(--gaq-size-space-30px) 2.1rem;
    }
  }

  &:hover {
    box-shadow: rgba(80, 80, 80, 0.7) 0px var(--gaq-size-space-3px)
      var(--dui-size-space-4x) 0px;

    .accordion {
      & > div:not(.accordionPanel) {
        button {
          box-shadow: rgba(80, 80, 80, 0.7) 0px var(--dui-size-space-4x)
            var(--gaq-size-space-5px) var(--gaq-size-space--5px);
        }
      }
    }
  }

  &:focus,
  &:focus-within {
    box-shadow: 0 2px 7px 1px var(--dui-color-gray-500);
    box-shadow: 0 var(--dui-size-space-1x) var(--gaq-size-space-7px)
      var(--gaq-size-space-1) var(--dui-color-gray-500);
    outline: 2px solid transparent;

    .accordion {
      & > div:not(.accordionPanel) {
        button {
          box-shadow: 0 var(--gaq-size-space-4x) var(--gaq-size-space-5px)
            var(--gaq-size-space--5px) var(--dui-color-gray-500);
        }
      }
    }
  }

  @media print {
    padding: var(--gaq-size-space-10x);
    page-break-after: always;
    page-break-inside: avoid;
    margin-top: var(--gaq-size-space-30px);

    & .accordion > dd {
      height: auto;
    }
  }
`;

const CardContentPaddingMobile = "20px 10px 30px";
const CardContentPaddingTablet = "30px 20px";
const CardContentPaddingDesktop = "25px 30px";

export const OfferCardContent = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 190px;
  padding: ${CardContentPaddingMobile};

  @media screen and (min-width: ${breakpoints.tablet}) {
    padding: ${CardContentPaddingTablet};
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 0;
  }

  @media screen and (min-width: ${breakpoints.desktop}) {
    padding: ${CardContentPaddingDesktop};
  }
`;

export const DeliveryInfoContent = styled.div`
  margin-bottom: var(--gaq-size-space-30px);

  @media screen and (min-width: ${breakpoints.tablet}) {
    flex-basis: 48rem;
  }

  @media screen and (min-width: ${breakpoints.desktop}) {
    margin-bottom: 0;
    flex-basis: 58rem;
  }

  @media all and (-ms-high-contrast: none) {
    width: 66%;
  }
`;

export const PaymentInfoContent = styled.div`
  display: block;
  position: relative;

  @media screen and (min-width: ${breakpoints.tablet}) {
    min-width: 280px;
  }

  @media screen and (min-width: ${breakpoints.desktop}) {
    width: 280px;
  }

  &.has-discount {
    position: relative;
  }
`;

export const StyledAccordion = styled(Accordion)`
  position: relative;
  padding: 0;

  .accordion {
    width: 100%;

    & > div > button:focus {
      outline: 1px dotted var(--dui-color-gray-700);
    }

    & > div:not(.accordionPanel) {
      button {
        position: absolute;
        z-index: 1;
        bottom: -20px;
        background: #fff;
        box-shadow: rgb(229 229 229) 0 var(--gaq-size-space-9px)
          var(--dui-size-space-3x) var(--gaq-size-space--5px);
        transition: ease-in-out 200ms box-shadow;
      }
    }
  }
`;
export const OfferCardDetailsContent = styled.div`
  padding-top: var(--gaq-size-space-30px);
  padding-bottom: 0;
  margin-left: var(--dui-size-space-5x);
  margin-right: var(--dui-size-space-5x);
  border-top: var(--dui-size-width-border-xs) solid var(--dui-color-gray-200);
  display: flex;
  flex-direction: column;
  justify-content: center;

  @media screen and (min-width: ${breakpoints.tablet}) {
    padding-top: var(--gaq-size-space-35px);
    padding-bottom: ${(props) =>
      props.shouldRenderQuoteValidity ? "0" : "40px"};
    margin-left: var(--dui-size-space-10x);
    margin-right: var(--dui-size-space-10x);
    flex-direction: row;
    justify-content: space-between;
    align-items: baseline;

    > div {
      width: 50%;

      &:first-child {
        margin-right: 0;
      }
    }
  }

  @media screen and (min-width: ${breakpoints.desktop}) {
    padding-top: var(--dui-size-space-10x);
    margin-left: var(--gaq-size-space-30px);
    margin-right: var(--gaq-size-space-30px);

    > div:first-child {
      margin-right: var(--dui-size-space-64x);
    }
  }
`;

export const OfferCardPriceDiscount = styled.div`
  background: var(--dui-colors-background-highlight);
  border-top-left-radius: var(--dui-size-radius-md);
  clip-path: polygon(0 0, 100% 0%, 89.25% 100%, 0% 100%);
  color: var(--dui-colors-foreground-inverted);
  font-size: var(--dui-size-font-xs);
  font-style: italic;
  height: 19px;
  left: 0;
  line-height: 18px;
  padding-left: var(--dui-size-space-12x);
  position: absolute;
  top: 0;
  width: 121px;
`;
